module.exports = __webpack_public_path__ + "img/images.5f0176ec.png";